import { css } from 'styled-components';

export const MatrixSkin = css`
  background-color: #000;
  border: 1px solid #58ff00;
`;

export const MatrixWrapperSkin = css`
  background: #000;
`;

export const MatrixLetterSkin = css<{ $isActive: boolean }>`
  color: ${props => (props.$isActive ? '#58ff00' : '#fff')};
  opacity: ${props => (props.$isActive ? 1 : 0.2)};
`;
